import React from 'react';

import {HiUser} from 'react-icons/hi';
import {AiFillLock} from 'react-icons/ai';
import {FaBandcamp, FaNetworkWired} from 'react-icons/fa';
import {IoMdNotifications} from 'react-icons/io';
import IntlMessages from '@crema/helpers/IntlMessages';
import {
  StyledUserProfileContainer,
  StyledUserProfileTabs,
} from './index.styled';
import AppAnimate from '@crema/components/AppAnimate';
import {accountData} from '@crema/mockapi/fakedb';
import {
  ChangePassword,
  Information,
  PersonalInfo,
  SocialLink,
  Notification,
} from '@crema/modules/profile/UserProfile';

const items = [
  {
    label: (
      <span className='user-profile-icon'>
        <HiUser className='icon' />
        <span>
          <IntlMessages id='userProfile.personalInfo' />
        </span>
      </span>
    ),
    key: '01',
    children: <PersonalInfo />,
  },
];

const UserProfile = () => {
  return (
    <StyledUserProfileContainer>
      <AppAnimate animation='transition.slideUpIn' delay={200}>
        <StyledUserProfileTabs
          key='1'
          defaultActiveKey='01'
          tabPosition='left'
          items={items}
        />
      </AppAnimate>
    </StyledUserProfileContainer>
  );
};

export default UserProfile;
